import { useCallOnEachValue } from '@mc/hooks'
import { useVideo } from '.'

/**
 * Drive whether the video is playing from a boolean prop `playing`
 */
export const VideoExternalPlayState = ({ playing }: { playing: boolean }) => {
  const { play, pause, readyState, state } = useVideo()

  useCallOnEachValue(
    (_, [shouldPlay]) => {
      if (readyState !== 'ready') {
        return
      }

      if (shouldPlay && (state === 'paused' || state === 'idle')) {
        play()
      } else if (!shouldPlay && state === 'playing') {
        pause()
      }
    },
    [playing, readyState],
  )

  return null
}
